// PRE-2378 — SURID (immutable golden record id): details incl. XREFs + merge history.
export const GET_SURID_DETAILS_REQUEST = "GET_SURID_DETAILS_REQUEST";
export const GET_SURID_DETAILS_SUCCESS = "GET_SURID_DETAILS_SUCCESS";
export const GET_SURID_DETAILS_FAILURE = "GET_SURID_DETAILS_FAILURE";

export const getSurIdDetailsRequest = (surId) => ({ type: GET_SURID_DETAILS_REQUEST, params: { surId } });
export const getSurIdDetailsSuccess = (details) => ({ type: GET_SURID_DETAILS_SUCCESS, payload: details });
export const getSurIdDetailsFailure = (error) => ({ type: GET_SURID_DETAILS_FAILURE, payload: error });
